<template>
  <business-form
    :form-data.sync="formData"
    :loading="isLoading"
    @submit="onSubmit"
    @cancel="onCancel"
  />
</template>

<script>
import Logo from '@core/layouts/components/Logo.vue';
import { ref, onUnmounted, watch } from '@vue/composition-api';
import Ripple from 'vue-ripple-directive';
import store from '@/store';
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BOverlay,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useToast } from 'vue-toastification/composition';

import router from '@/router';
import BusinessForm from './BusinessForm.vue';
import businessStoreModule from './BusinessStoreModule';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    BOverlay,
    flatPickr,
    vSelect,
    Logo,
    BusinessForm,
    ToastificationContent,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  setup() {
    const toast = useToast();

    const BUSINESS_APP_STORE_MODULE_NAME = 'business';

    // Register module
    if (!store.hasModule(BUSINESS_APP_STORE_MODULE_NAME))
      store.registerModule(BUSINESS_APP_STORE_MODULE_NAME, businessStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(BUSINESS_APP_STORE_MODULE_NAME))
        store.unregisterModule(BUSINESS_APP_STORE_MODULE_NAME);
    });

    const isLoading = ref(false);
    const formData = ref(null);

    watch(
      formData,
      (newVal) => {
        console.log('=== formData', JSON.stringify(newVal, null, 2));
      },
      {
        deep: true,
      }
    );

    const onSubmit = async () => {
      console.log('=== Invoice Add On Submit', JSON.stringify(formData.value, null, 2));

      isLoading.value = true;

      store
        .dispatch('business/addBusiness', {
          ...formData.value,
          entity: {
            ...formData.value.entity,
            docNo: generateRandomString(),
          },
        })
        .then((response) => {
          console.log('=== Business Add On Submit Response', response);

          toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              icon: 'CheckCircleIcon',
              variant: 'success',
              text: 'Business Added Successfully',
            },
          });

          router.push({ name: 'business-view', params: { id: response.entity.id } });
        })
        .catch((error) => {
          console.error('Error adding business:', error);

          toast({
            component: ToastificationContent,
            props: {
              title: 'Error Adding Business',
              icon: 'AlertCircleIcon',
              variant: 'danger',
              text: error.message,
            },
          });
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    const onCancel = () => {
      router.go(-1);
    };

    return {
      isLoading,
      formData,
      onSubmit,
      onCancel,
    };
  },
};
</script>
